import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { AdmissionReasonResponse } from "../../models/dtos";

export const admissionReasonsApi = createApi({
  reducerPath: "admissionReasonsApi",
  baseQuery: baseAuthQuery("AdmissionReasons"),
  tagTypes: ["AdmissionReason"],
  endpoints: (builder) => ({
    getAdmissionReasons: builder.query<ApiResponse<AdmissionReasonResponse[]>, void>({
      query: () => "",
      providesTags: ["AdmissionReason"],
    }),
    getAdmissionReasonById: builder.query<ApiResponse<AdmissionReasonResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["AdmissionReason"],
    }),
    updateAdmissionReason: builder.mutation<ApiResponse<AdmissionReasonResponse>, Partial<AdmissionReasonResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["AdmissionReason"],
    }),
    deleteAdmissionReason: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["AdmissionReason"],
    }),
  }),
});
